export const PreventLinkClick = {
  mounted() {
    this.el.addEventListener("click", (e) => {
      e.preventDefault();
    });
  },
};
